<template>
  <div>
    <el-form ref="formRef" :model="ruleForm" label-width="160px">
      <el-form-item label="奖惩类型：">
        {{ruleForm.type > 0?'奖励':'惩罚'}}
      </el-form-item>
      <el-form-item label="行为：">
        {{ruleForm.action == 1?'聊天':ruleForm.action == 2?'纸条':ruleForm.action == 3?'动态':''}}
      </el-form-item>
      <el-form-item label="奖惩操作：">
        {{ruleForm.name}}
      </el-form-item>
      <el-form-item label="积分数量：">
        <el-input v-model="ruleForm.integral" placeholder="请输入积分数量" style="width: 90%" ></el-input>
      </el-form-item>
      <el-form-item label="单位：">
        {{ruleForm.unit == 1?'每人':ruleForm.unit == 2?'每条':ruleForm.unit == 3?'每密度':''}}
      </el-form-item>
      <el-form-item label="当前上限（分）：">
        <el-input v-model="ruleForm.currentMax" placeholder="请输入积分数量" style="width: 90%" ></el-input>
      </el-form-item>
      <el-form-item label="当天上限（分）：">
        <el-input v-model="ruleForm.everydayMax" placeholder="请输入积分数量" style="width: 90%" ></el-input>
      </el-form-item>
      <el-form-item label="备注：">
                {{ruleForm.remark}}
      </el-form-item>
      <el-form-item label="状态：">
        <el-radio-group v-model="ruleForm.state">
          <el-radio :label="0">停用</el-radio>
          <el-radio :label="1">启用</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit" v-loading="loading">确定</el-button>
    </div>
  </div>
</template>

<script>
import {postFormData} from "@/api/api";
import {updateIntegralRule} from "@/api/url";

export default {
  name: "UpdateApplyStateDialog",
  props: {
    value: Object
  },
  data() {
    return {
      ruleForm: this.value.ruleForm,
      loading: false,
    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    submit() {
      this.loading = true
      let param = {}
      param['id'] = this.ruleForm.id
      param['integral'] = this.ruleForm.integral
      param['currentMax'] = this.ruleForm.currentMax
      param['everydayMax'] = this.ruleForm.everydayMax
      param['state'] = this.ruleForm.state
      postFormData(updateIntegralRule, param).then((data) => {
        let {code, msg} = data;
        if ( code == 200 ) {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'success'
          })
          this.$emit('confirm', param)
        } else {
          this.$message({
            message: msg,
            duration: 2000,
            type: 'warning'
          })
        }
        this.loading = false
      }).catch(()=>{
        this.loading = false
      })
    }

  }
}
</script>

<style scoped>

</style>
